import { Motion } from '@legendapp/motion';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';
import { Easing, StyleSheet, useWindowDimensions } from 'react-native';

import { useFloorMapPresenter } from '../FloorMapPresenter';

const ANIMATION_DURATION = 550;

type Props = {
  children?: ReactNode;
};

export const FloorMapAnimatedWrapper = observer(
  function FloorMapAnimatedWrapper({ children }: Props) {
    const { width, height } = useWindowDimensions();
    const { animationStates, extendedMapVisible } = useFloorMapPresenter();

    const animationState = extendedMapVisible
      ? animationStates.extendedMap.animate
      : animationStates.extendedMap.initial;

    return (
      <Motion.View
        style={[
          styles.wrapper,
          {
            height,
            width,
          },
        ]}
        key='extended-map-animated-view' // Required for legend motion package to animate properly
        animate={animationState}
        transition={{
          duration: ANIMATION_DURATION,
          type: 'timing',
          easing: Easing.inOut(Easing.ease),
        }}
      >
        {children}
      </Motion.View>
    );
  }
);

const styles = StyleSheet.create({
  wrapper: {
    alignItems: 'center',
    justifyContent: 'center',
  },
});
